export default class AdminAppointments {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminAppointmentsRoute}`, {
      params
    })
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminAppointmentsRoute}/${id}`, {})
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminAppointmentsRoute}`, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminAppointmentsRoute}/${id}`, payload, {})
  }

  complete(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminAppointmentsRoute}/${id}/complete`, payload)
  }

  cancel(id) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminAppointmentsRoute}/${id}/cancel`, {})
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.adminAppointmentsRoute}/${id}`, {})
  }

  startConsultation(id) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminAppointmentsRoute}/${id}/start-consultation`, {})
  }

  confirm(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminAppointmentsRoute}/${id}/confirm`, payload, {})
  }
}
